import AuthActions, { types as AuthActionTypes } from '/b2b/authentication/state/Auth.actions';
import { refreshTokens, signOut } from '/b2b/authentication/services';
import { shouldRefreshTokens, shouldRemember } from '/b2b/authentication/state/Auth.selectors';

import Actions from '../state/ui/UI.actions';
import { CRUDActionTypes } from '../helpers/ReduxHelpers';
import fromState from '../state/selectors';
import { updateTokens } from '/b2b/amplify.config';

const authActions = Object.values(AuthActionTypes);

export default ({ dispatch, getState }) =>
    next =>
    action => {
        const state = getState();
        const { type, payload = {}, meta } = action;
        // Only refresh tokens all of the following conditions are met:
        const refresh =
            fromState.Auth.isAuthenticated(state) && // User is authenticated
            !meta?.noRefresh && // Meta noRefresh flag is not set
            payload?.error !== 'Aborted' && // Request was not aborted
            !authActions.includes(type); // Action is not an auth action
        if (refresh) {
            // Check for expired session / id tokens and refresh if necessary
            refreshTokens()
                .then(session => {
                    shouldRefreshTokens(state, session) &&
                        dispatch(AuthActions.refreshTokens(session.tokens));
                })
                .catch(() => {
                    // Could not refresh tokens
                    dispatch(AuthActions.logout());
                });
        }
        // Action could be a thunk
        if (type) {
            const { params, error, response = payload } = payload || {};
            const actionType = type.split('/').pop();
            if (Object.values(CRUDActionTypes).includes(actionType)) {
                if (type.slice(-5).toLowerCase() === 'begin') {
                    dispatch(Actions.asyncBegin(meta, params));
                } else if (type.slice(-7).toLowerCase() === 'success') {
                    dispatch(Actions.asyncSuccess(meta, params, response));
                } else {
                    dispatch(Actions.asyncFailure(meta, params, error));
                }
            }
            switch (type) {
                case `${AuthActions.logout}`: {
                    // It's async, but we fire once
                    signOut({ rememberMe: shouldRemember(getState()) }).finally(() => {
                        // This will clear the tokens, and we do it after the logout so the backend can see who was logged in
                        updateTokens();
                    });
                    break;
                }
            }
        }

        return next(action);
    };
